import '../../vendors/slick-carousel/slick/slick.css';
import '../../vendors/WellScroller/scroller.css';
// import '../../vendors/malihu-custom-scrollbar-plugin-master/jquery.mCustomScrollbar.min.css';


// WEBPACK FOOTER //
// ./src/assets/js/vendor/style-vendor.js